import { render, staticRenderFns } from "./ArticleUnitPrompt.vue?vue&type=template&id=1de0396e&scoped=true&"
import script from "./ArticleUnitPrompt.vue?vue&type=script&lang=js&"
export * from "./ArticleUnitPrompt.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1de0396e",
  null
  
)

export default component.exports